import LoadingModal from '@/js/components/organisms/modals/LoadingModal.vue';
import { mountModal } from './helper/dynamic-modal';

export const loading = ({ asyncFunc, text }: { asyncFunc?: () => Promise<unknown>; text?: string }) =>
  mountModal({
    Component: LoadingModal,
    props: { loadingText: text },
    ...(asyncFunc && { asyncFunc }),
  });
